export default __webpack_public_path__ + "static/lazurny-5d28c1acf4b590862340e3a83fe7faee.png";